import axios from "../api/axios";
import useAuth from "./useAuth";
import Cookies from "js-cookie";

const useLogout = () => {
    const { setAuth } = useAuth();

    const logout = async () => {
        setAuth({});
        Cookies.remove('name')
        try {
            await axios('/logout', {
                withCredentials: true
            });
        } catch (err) {
            console.error('');
        }
    }

    return logout;
}

export default useLogout